export default "__VITE_ASSET__rjswAEhP__"